import React from 'react';
import { CTAButton } from './CTAButton';
export const HeroSection = () => {
  return <section className="w-full bg-[#faf7f2] py-16 px-4 md:px-8 lg:px-16" data-id="element-106">
      <div className="max-w-6xl mx-auto" data-id="element-107">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-108">
          <div className="md:w-1/2 order-2 md:order-1" data-id="element-109">
            <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 leading-tight mb-4" data-id="element-110">
             "Jak sprawić, żeby mąż znowu CIĘ PRAGNĄŁ - 47-letnia Marta odkryła sekret 4,000+ polskich kobiet"
            </h1>
            <p className="text-lg md:text-xl text-gray-700 mb-6" data-id="element-111">
              Najnowsze dane GUS pokazują, że ponad 63% małżeństw z 15+ letnim
              stażem doświadcza kryzysu intymności. Poznaj historię Marty, która
              znalazła rozwiązanie, gdy jej małżeństwo stanęło na krawędzi.
            </p>
            <CTAButton text="Chcę przerwać Błędne Koło" data-id="element-112" />
          </div>
          <div className="md:w-1/2 order-1 md:order-2" data-id="element-113">
            <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rA3BXmJrOkGt7NVjSFAKDwfocyOz5aYMgXnZL4" alt="Kobieta stojąca w progu sypialni" className="w-full h-auto rounded-lg shadow-lg" data-id="element-114" />
          </div>
        </div>
      </div>
    </section>;
};